import React, { Component } from 'react'
import FAQPage from '../../components/FAQ/FaqPage'

class FAQPageContainer extends Component {
  render() {
    return (
        <FAQPage />
    )
  }
}

export default FAQPageContainer


// WEBPACK FOOTER //
// ./src/containers/FAQ/FaqPage.js